import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Calendar, ExternalLink } from 'lucide-react';

const STATUS_COLORS = {
  nieuw: 'bg-yellow-500/20 text-yellow-300',
  in_behandeling: 'bg-blue-500/20 text-blue-300',
  offerte_verstuurd: 'bg-purple-500/20 text-purple-300',
  goedgekeurd: 'bg-emerald-500/20 text-emerald-300',
  gepland: 'bg-cyan-500/20 text-cyan-300',
  afgerond: 'bg-emerald-500/20 text-emerald-300',
  geannuleerd: 'bg-red-500/20 text-red-300',
};

const STATUS_LABEL_NL = {
  nieuw: 'Nieuw',
  in_behandeling: 'In behandeling',
  offerte_verstuurd: 'Offerte verstuurd',
  goedgekeurd: 'Goedgekeurd',
  gepland: 'Gepland',
  afgerond: 'Afgerond',
  geannuleerd: 'Geannuleerd',
};

const MyProjectsList = ({ requests, navigate, i18n, t }) => {
  const fmtDate = (d) => d ? new Date(d).toLocaleDateString(i18n.language === 'nl' ? 'nl-NL' : 'en-US', { day: 'numeric', month: 'short', year: 'numeric' }) : '';
  return (
    <div className="max-w-7xl mx-auto">
      <h2 className="text-2xl font-bold text-white mb-4">{t('myRequests')}</h2>
      {requests.length === 0 ? (
        <Card className="bg-[#0d3d3d]/60 border-white/10">
          <CardContent className="py-10 text-center text-white/60">
            <Calendar className="w-10 h-10 mx-auto mb-2 text-white/30" />
            <p className="text-sm">{i18n.language === 'nl' ? 'U heeft nog geen aanvragen.' : 'No requests yet.'}</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid gap-4">
          {requests.map((r) => {
            const statusKey = (r.status || 'nieuw');
            const color = STATUS_COLORS[statusKey] || 'bg-gray-500/20 text-gray-300';
            const label = STATUS_LABEL_NL[statusKey] || statusKey;
            return (
              <Card key={r.id} className="bg-[#0d3d3d]/90 border-white/20 hover:border-[#3da5a5]/50 transition-all">
                <CardContent className="p-5 space-y-3">
                  <div className="flex items-start justify-between gap-3 flex-wrap">
                    <div>
                      <h3 className="text-lg font-bold text-white">{r.title || (i18n.language === 'nl' ? 'Werkzaamheden' : 'Work')}</h3>
                      <p className="text-xs text-white/50 mt-1">{fmtDate(r.created_at)}</p>
                    </div>
                    <span className={`text-[11px] px-2 py-0.5 rounded-full ${color}`}>{label}</span>
                  </div>
                  {r.description && <p className="text-sm text-white/80 line-clamp-2">{r.description}</p>}
                  {r.address && <p className="text-xs text-white/60">📍 {r.address}</p>}
                  <Button
                    size="sm"
                    variant="outline"
                    className="border-white/30 text-white hover:bg-white/10"
                    onClick={() => navigate(`/client/work-requests/${r.id}`)}
                    data-testid={`client-view-request-${r.id}`}
                  >
                    <ExternalLink className="w-3 h-3 mr-1" />
                    {i18n.language === 'nl' ? 'Details bekijken & Updates' : 'View Details & Updates'}
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MyProjectsList;
